<div style="padding: 0.5rem 1rem;">
  <!-- todo - add an optional "title" input to show here-->

  <ng-content></ng-content>
</div>